export default __webpack_public_path__ + "static/media/email.aad0fcfd.svg";